import { Http } from "../Http";
import { ApiResponse } from "../../../Api/Model/ApiResponse.csharp";

export interface IInsuranceApi {
  requestBooking(data: FormData): Promise<ApiResponse>;
}

export class InsuranceApi implements IInsuranceApi {
  public requestBooking = (data: FormData): Promise<ApiResponse> => {
    return Http.post(`/api/request-booking`, data, "multipart/form-data") as Promise<ApiResponse>;
  };
}
